import { Col, Image } from "react-bootstrap";
import img from "../../assets/img/image.png";
import PropTypes from "prop-types";

const EmptyList = ({ imgSize, vhSize, title, description }) => {
  return (
    <Col
      style={{ position: "relative", textAlign: "center", height: `${vhSize}vh` }}
      className="d-flex flex-column align-items-center justify-content-center"
    >
      <Image
        src={img}
        height={imgSize}
        width={imgSize}
        style={{ objectFit: "contain" }}
      />
      <h2 style={{ marginTop: "-30px" }}>{title || "Nada por aqui..."}</h2>
      <p>{description || "Comece a adicionar novos registros"}</p>
    </Col>
  );
};

EmptyList.propTypes = {
  imgSize: PropTypes.number,
  vhSize: PropTypes.number,
  title: PropTypes.string,
  description: PropTypes.string
};

export default EmptyList;
